import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App'; // ✅ Coincide con App.tsx
import { msalConfig } from "./helpers/authConfig"; 
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { locale, loadMessages } from 'devextreme/localization';
import esMessages from 'devextreme/localization/messages/es.json';
import config from 'devextreme/core/config';
console.log('Clave de Licencia Cargada:', process.env.REACT_APP_DEVEXTREME_LICENSE_KEY);

config({ licenseKey: process.env.REACT_APP_DEVEXTREME_LICENSE_KEY });
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
const msalInstance = new PublicClientApplication(msalConfig);
loadMessages(esMessages);
locale('es');
root.render(
  <React.StrictMode>
   <MsalProvider instance={msalInstance}>
      <App />
    </MsalProvider>

  </React.StrictMode>
);
